import React from 'react';
import MViewDetailNotifFormListItems from './MViewDetailNotifFormListItems';
import LoadingButton from '../../../app/common/layout/LoadingButton';

export default function MViewDetailNotifFormList(props) {
  const { auth, scope, loading, items } = props;
  return (
    <>
      {loading && (
        <tr>
          <td rowSpan={4}>
            <LoadingButton />
          </td>
        </tr>
      )}
      {items?.[0] &&
        items.map((item, index) => (
          <MViewDetailNotifFormListItems
            auth={auth}
            scope={scope}
            key={index}
            index={index}
            item={item}
          />
        ))}
      {!items?.[0] && (
        <tr>
          <td colSpan={4}>Tidak ada data</td>
        </tr>
      )}
    </>
  );
}
